// removed by extract-text-webpack-plugin
module.exports = {"header":"DesktopHeader-module__header___3JDfM","content":"DesktopHeader-module__content___1F3NW","wide-screen":"DesktopHeader-module__wide-screen___2-poX","item":"DesktopHeader-module__item___1wHM6","logo":"DesktopHeader-module__logo___3AREX"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/DesktopHeader.module.scss
// module id = 236
// module chunks = 0 1